import React, { FunctionComponent, useState } from 'react'
import { AlertsStore } from '../../typings/stores/AlertsStore'
import Table, { SortDirection } from '../../components/Table/next'
import styles from './styles.module.css'
import { get } from 'lodash'
import { PaginationData } from '../../components/Pagination/next'
import { DateTimeDisplay, GenericButton } from '../../components'
import ViewAlert from './ViewAlert'
import { AlertSorts } from './index'
import { DateTime } from 'luxon'

const AlertsTable: FunctionComponent<{
  loading: boolean
  alerts: AlertsStore
  paginate: boolean
  sortable?: boolean
  onSortChange?: (by: AlertSorts, dir: SortDirection) => void
  sort?: any
  onPageSizeUpdate?: (pageSize: PaginationData['pageSize']) => void
  onPaginate?: (page: PaginationData['pageSize']) => void
}> = ({
  loading,
  alerts,
  paginate = true,
  sortable = true,
  onSortChange,
  sort,
  onPageSizeUpdate,
  onPaginate,
}) => {
  const [selectedAlert, setSelectedAlert] = useState(null)

  return (
    <>
      <Table
        className={styles.table}
        isLoading={loading}
        data={alerts.data}
        onSortChange={onSortChange}
        sort={sort}
        cols={[
          {
            className: styles.name,
            field: 'subject',
            sortable: sortable,
            text: 'Subject',
          },
          {
            field: 'timeSent',
            sortable: sortable,
            text: 'Sent',
            render: row => {
              const sentDate = DateTime.fromSQL(row.timeSent)

              return <DateTimeDisplay datetime={sentDate} />
            },
          },
          {
            text: 'View',
            className: styles.nostretch,
            render: alert => (
              <GenericButton
                onClick={() => {
                  setSelectedAlert(alert.id)
                }}
                small
              >
                Open
              </GenericButton>
            ),
          },
        ]}
        pagination={
          paginate
            ? {
                currentPage: get(alerts, 'pagination.currentPage', 0),
                onPageSizeUpdate: onPageSizeUpdate,
                onPaginate: onPaginate,
                pageSize: get(alerts, 'pagination.pageSize', 0),
                total: get(alerts, 'pagination.total', 0),
              }
            : undefined
        }
        enableSettings={false}
      />
      {selectedAlert && (
        <ViewAlert
          alertId={selectedAlert}
          close={() => setSelectedAlert(null)}
        />
      )}
    </>
  )
}

export default AlertsTable
